import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=7aa17274&scoped=true&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa17274",
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign({QPage}, component.options.components || {})
